import ReactMarkdown from "react-markdown";
import CustomAreaChart from "./AreaChart";
import CustomBarChart from "./BarChart";
import CustomLineChart from "./LineChart";
import CustomPieChart from "./PieChart";
import CustomScatterChart from "./ScatterChart";

import rehypeRaw from "rehype-react";
import { reactMarkdownComp } from "../../../../../../../../../Constants/reactMarkdownComp";
import { VisualizationOutput } from "../../types";
import ChartsErrorBoundary from "../ChartsErrorBoundary";

type Props = { output: VisualizationOutput };

const CustomCharts = ({ output }: Props) => {
  const { data: chart } = output;

  if (!chart)
    return (
      <ReactMarkdown
        children={"Error with Chart Generation"}
        //remarkPlugins={[remarkGfm]} removed because it was causing the markdown to not render properly
        rehypePlugins={[rehypeRaw] as any}
        components={reactMarkdownComp}
      />
    );

  return (
    <>
      {output.summary && (
        <ReactMarkdown
          children={output?.summary}
          //remarkPlugins={[remarkGfm]} removed because it was causing the markdown to not render properly
          rehypePlugins={[rehypeRaw] as any}
          components={reactMarkdownComp}
        />
      )}
      <ChartsErrorBoundary>
        {chart.chartType === "bar" && <CustomBarChart chart={chart} />}
        {chart.chartType === "scatter" && <CustomScatterChart chart={chart} />}
        {chart.chartType === "pie" && <CustomPieChart chart={chart} />}
        {chart.chartType === "area" && <CustomAreaChart chart={chart} />}
        {chart.chartType === "line" && <CustomLineChart chart={chart} />}
      </ChartsErrorBoundary>
    </>
  );
};

export default CustomCharts;
